// Collapsed-sidebar rail width in px. Shared between Sidebar.tsx (the rail's
// own width) and SidebarNavListItem.tsx (each collapsed item's width, so icons
// stay centered within the rail) — kept in one place so the two can't drift.
export const SIDEBAR_COLLAPSED_WIDTH = 64;

// Left padding that centers an icon/avatar of the given size inside the
// collapsed rail — used as a fixed value in BOTH collapsed and expanded
// states (not just collapsed) so that toggling never shifts the icon
// horizontally. Shared so SidebarNavListItem.tsx's nav icons and Sidebar.tsx's
// account avatar derive from SIDEBAR_COLLAPSED_WIDTH instead of each hand-
// computing (and risking drifting from) their own copy of the same number.
export const centerInCollapsedRail = (contentSizePx: number) =>
  (SIDEBAR_COLLAPSED_WIDTH - contentSizePx) / 2;
